import { Component, OnInit, inject } from "@angular/core";
import GridsConfig from "@app/common/grid.config";
import { ApiService } from "@app/services/api.service";
import { DialogService } from "@app/services/dialog.service";
import { MigrationService } from "@app/services/migration.service";
import { ToastService } from "@app/services/toast.service";

@Component({
  selector: "app-queued-migrations",
  templateUrl: "./queued-migrations.component.html",
  styleUrls: ["./queued-migrations.component.scss"],
  standalone: false,
})
export class QueuedMigrationsComponent implements OnInit {
  private readonly apiService = inject(ApiService);
  private readonly dialogService = inject(DialogService);
  private readonly migrationService = inject(MigrationService);
  private readonly toastService = inject(ToastService);

  queuedMigrations: any[] = [];
  queuedTableRows: any[] = [];
  loading = false;
  isAutoLoadChecked = true;
  queuedDisplayedColumns = GridsConfig.QueuedMigrations.Columns;
  queuedHeaders = GridsConfig.QueuedMigrations.Headers;

  ngOnInit() {
    this.loadQueuedMigrations();
  }

  loadQueuedMigrations() {
    this.loading = true;
    this.apiService.getQueuedMigrations().subscribe({
      next: (data: any[]) => {
        this.queuedMigrations = data;
        this.queuedTableRows = data.map((migration, index) => ({
          ...migration,
          position: index + 1,
          created_dt_local: this.migrationService.formatDateForDisplay(
            migration.created_dt,
          ),
          status: migration.status || "queued",
        }));
        this.loading = false;
      },
      error: () => {
        this.queuedMigrations = [];
        this.queuedTableRows = [];
        this.loading = false;
      },
    });
  }

  executeQueuedMigrations(_event: any | null): void {
    this.loadQueuedMigrations();
  }

  onQueuedDequeueButtonClicked(migration: any): void {
    this.dequeueMigration(migration.id, migration.company_name);
  }

  dequeueMigration(migrationId: number, companyName: string) {
    this.dialogService.openConfirmDialog({
      title: "Remove queued migration",
      message: "Are you sure you want to remove this migration from the queue?",
      additionalMessage: `\"${companyName}\" (ID: ${migrationId})`,
      confirmText: "Remove",
      cancelText: "Cancel",
      confirmTextStyle: "warning-btn",
      onConfirm: () => {
        this.apiService.dequeueMigration(migrationId).subscribe({
          next: () => {
            this.loadQueuedMigrations();
            this.toastService.success(
              `Migration "${companyName}" (ID: ${migrationId}) has been removed.`,
            );
          },
          error: (err: any) => {
            console.error("Failed to dequeue", err);
            this.toastService.error(
              `Failed to remove migration "${companyName}" (ID: ${migrationId}).`,
            );
          },
        });
      },
    });
  }

  dequeueAllMigrations() {
    this.dialogService.openConfirmDialog({
      title: "Remove all queued migrations",
      message: "Are you sure you want to clear the migration queue?",
      additionalMessage: `${this.queuedMigrations.length} migration(s) will be removed.`,
      confirmText: "Clear All",
      cancelText: "Cancel",
      confirmTextStyle: "warning-btn",
      onConfirm: () => {
        this.apiService.dequeueAllMigrations().subscribe({
          next: () => {
            this.loadQueuedMigrations();
            this.toastService.success(
              "All queued migrations have been removed.",
            );
          },
          error: (err: any) => {
            console.error("Failed to dequeue all", err);
            this.toastService.error("Failed to remove all queued migrations.");
          },
        });
      },
    });
  }
}
